"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClientHmy = exports.createClientWeb3 = void 0;
const tslib_1 = require("tslib");
const web3_1 = (0, tslib_1.__importDefault)(require("web3"));
const core_1 = require("@harmony-js/core");
const utils_1 = require("@harmony-js/utils");
const OneBTCClientHmy_1 = require("./OneBTCClientHmy");
const OneBTCClientWeb3_1 = require("./OneBTCClientWeb3");
const btcNode_1 = require("../../btcNode");
const createClientWeb3 = async (params) => {
    let nodeURL = params.nodeURL;
    if (params.useMetamask) {
        if (typeof window === 'object' && window.web3) {
            nodeURL = window.web3.currentProvider;
        }
        else {
            throw new Error("Can't find metamask");
        }
    }
    const web3 = new web3_1.default(nodeURL);
    const btcNodeClient = new btcNode_1.BTCNodeClient(params.btcNodeUrl);
    const methods = new OneBTCClientWeb3_1.OneBTCClientWeb3({
        useMetamask: params.useMetamask,
        web3,
        contractAddress: params.contractAddress,
        stakingContractAddress: params.stakingContractAddress,
        nodeURL: params.nodeURL,
        btcNodeClient,
    });
    await methods.init();
    return methods;
};
exports.createClientWeb3 = createClientWeb3;
const createClientHmy = async (params) => {
    const btcNodeClient = new btcNode_1.BTCNodeClient(params.btcNodeUrl);
    const hmy = new core_1.Harmony(params.nodeURL, {
        chainType: utils_1.ChainType.Harmony,
        chainId: Number(params.chainId),
    });
    const client = new OneBTCClientHmy_1.OneBTCClientHmy({
        useOneWallet: params.useOneWallet,
        hmy,
        contractAddress: params.contractAddress,
        nodeURL: params.nodeURL,
        btcNodeClient,
    });
    await client.init();
    return client;
};
exports.createClientHmy = createClientHmy;
